var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.625C15.125 2.875 15.5 3.40625 15.5 4C15.5 10.9375 11.25 14.7812 8.5625 15.9062C8.1875 16.0625 7.78125 16.0625 7.40625 15.9062C4.0625 14.5 0.5 10.2188 0.5 4C0.5 3.40625 0.84375 2.875 1.40625 2.625L7.40625 0.125C7.59375 0.0625 7.78125 0.03125 8 0.03125C8.1875 0.03125 8.375 0.0625 8.5625 0.125L14.5625 2.625ZM8.1875 14.9688C11.25 13.75 14.5 9.5 14.4688 4C14.5 3.8125 14.375 3.625 14.1875 3.5625L8.1875 1.0625C8.0625 1 7.90625 1 7.78125 1.0625L1.78125 3.5625C1.59375 3.625 1.5 3.8125 1.5 4C1.5 9.5 4.75 13.75 7.78125 14.9688C7.90625 15.0312 8.0625 15.0312 8.1875 14.9688ZM8 12.8438C5.9375 11.7188 3.84375 8.75 3.53125 5L8 3.125V12.8438ZM7 10.7812V4.625L4.59375 5.625C4.9375 7.71875 5.84375 9.53125 7 10.7812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt);
export default __webpack_public_path__ + "static/media/shield-alt.5acdbd516e3d1a28463a0802c5854556.svg";
export { ForwardRef as ReactComponent };